export default __webpack_public_path__ + "static/media/image.itradelanka.ef14dbb3.png";